import React from 'react'

import { Link } from 'gatsby'

import AccountNav from '@components/Header/AccountNav'
import PromotionalBanner from '@components/Header/PromotionalBanner'
import HeaderMenu from '@components/HeaderMenu/HeaderMenu'
import Container from '@components/Layout/Container'

import { useThemeSettings } from '@hooks/useThemeSettings'

import * as styles from './Header.module.scss'

import Sales from '@icons/sales.svg'

interface Props {
	template: string
}

const Header: React.FC<Props> = (props) => {
	const [menuToggle, setMenuToggle] = React.useState(false)

	const themeSettings = useThemeSettings()

	const hideMenu = ['basket', 'checkout'].includes(props.template)

	const headerStyles = [styles.header]

	const toggleMenu = () => {
		setMenuToggle(!menuToggle)
	}

	if (hideMenu) {
		headerStyles.push(styles.hideMenu)
	}

	return (
		<header className={headerStyles.join(' ')} id="header">
			<PromotionalBanner className={styles.banner} />

			<div className={styles.mobile}>
				<Container className={styles.container}>
					<Link to="/" className={styles.logo} title="Versaclimber" aria-label="Versaclimber Homepage">
						<img
							src="/logo-light.png"
							alt="Versaclimber"
							className={styles.logoDesktop}
							loading="eager"
							width={292}
							height={43}
						/>
						<img
							src="/logo-mobile.png"
							alt="Versaclimber"
							className={styles.logoMobile}
							loading="eager"
							width={54}
							height={30}
						/>
					</Link>

					<AccountNav menuToggle={toggleMenu} isMenuOpen={menuToggle} hideMenu={hideMenu} />
				</Container>

				<HeaderMenu isMenuOpen={menuToggle} />
			</div>

			<div className={styles.desktop}>
				<div className={styles.top}>
					<Container className={styles.topContainer}>
						<div className={styles.salesNumber}>
							<Sales className={styles.icon} />

							<p>
								<strong>Sales:</strong>{' '}
								<a href={`tel:${themeSettings.salesNumber.replace(' ', '')}`}>
									{themeSettings.salesNumber}
								</a>
							</p>
						</div>

						<AccountNav menuToggle={toggleMenu} isMenuOpen={menuToggle} hideMenu={true} />
					</Container>
				</div>

				<Container className={styles.bottom}>
					<Link to="/" className={styles.logo} title="Versaclimber" aria-label="Versaclimber Homepage">
						<img src="/logo-light.png" alt="Versaclimber" loading="eager" width={292} height={43} />
					</Link>

					<HeaderMenu isMenuOpen={menuToggle} className={styles.menu} />
				</Container>
			</div>
		</header>
	)
}

export default Header
